import React from "react";
import {cx} from "../../../lib/ClassSet";
import "./ProductItem.css";

const ProductItem = (props) => {

  let {data} = props;

  let classes = cx({
    "item": true,
    "item-t-bundle": data.get("type") === "bundle",
    "inventory-product-list-item": true,
    "u-selected": props.selected
  })

  return (
    <tr className={classes} onClick={(e) => props.onClick(data, e)}>
      <td className="field f-sku">{data.get("sku")}</td>
      <td className="field f-title">{data.get("title")}</td>
      <td className="field f-nr-bundled">{data.get("nrBundled")}</td>
    </tr>
  )
}

export default ProductItem;